import { render, staticRenderFns } from "./Frauds.vue?vue&type=template&id=36e3e913&scoped=true&"
import script from "./Frauds.vue?vue&type=script&lang=js&"
export * from "./Frauds.vue?vue&type=script&lang=js&"
import style0 from "./Frauds.vue?vue&type=style&index=0&id=36e3e913&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3e913",
  null
  
)

export default component.exports